import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CustomTooltip, CustomXAxisTick, useTooltipToggle } from '../shared';

interface SpO2ChartProps {
  data: any[];
}

/**
 * SpO2グラフコンポーネント
 * 酸素飽和度の推移を折れ線グラフで表示
 */
export const SpO2Chart: React.FC<SpO2ChartProps> = ({ data }) => {
  const { tooltipActive, handleChartClick, handleChartLeave } = useTooltipToggle();

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data}
        margin={{ top: 20, right: 20, left: -15, bottom: 20 }}
        onClick={handleChartClick}
        onMouseLeave={handleChartLeave}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          dataKey="date"
          tick={<CustomXAxisTick />}
          stroke="#666"
          interval={0}
        />
        <YAxis
          domain={[90, 100]}
          ticks={[90, 92, 94, 96, 98, 100]}
          tick={{ fontSize: 16, fontWeight: 'bold' }}
          stroke="#666"
          axisLine={false}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip chartData={data} />} active={tooltipActive} trigger="click" />
        <Line
          type="linear"
          dataKey="spo2"
          name="SpO2"
          stroke="#888888"
          strokeWidth={2}
          dot={{ fill: '#808080', r: 7, stroke: '#ffffff', strokeWidth: 1 }}
          activeDot={tooltipActive ? { r: 9 } : false}
          connectNulls
          animationDuration={600}
          animationEasing="ease-out"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SpO2Chart;
